"use client";

import { c as _c } from "react/compiler-runtime";
import { LinkIcon } from "@heroicons/react/24/outline";
import { Button, cn, handleCopyClipboard } from "@saridana-core/react-ui-kit";
import { ArticleCategory, TArticle } from "@shared/types";
import { HtmlParser } from "@shared/ui";
import { FacebookIcon, LinkedinIcon, WhatsappIcon, XIcon } from "@shared/ui/custom-icon";
import { ReplacementsMap } from "@shared/ui/html-parser";
import { formatDate, mapAttribsToProps } from "@shared/utils";
import { domToReact, HTMLReactParserOptions } from "html-react-parser";
import Image from "next/image";
import Link from "next/link";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
export function ArticleContentSection(t0) {
  const $ = _c(61);
  const {
    fullTitle,
    content,
    publishedDate,
    image,
    slug,
    tags,
    categories,
    category
  } = t0;
  const baseOrigin = typeof window !== "undefined" && window.location.origin ? window.location.origin : "";
  const url = `${baseOrigin}/${category}/${slug}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      default: {
        background: "bg-white",
        border: "border-gray-200"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const contentVariantMap = t1;
  let t2;
  if ($[1] !== tags) {
    t2 = tags || [];
    $[1] = tags;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const tagsData = t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (domNode_0, options_0) => {
      const attribs = domNode_0.attribs || {};
      const props = mapAttribsToProps(attribs);
      const mergedClass = cn("relative w-full min-w-full", contentVariantMap.default.border, props.className);
      delete props.className;
      return <figure {...props} className={mergedClass}>{domToReact(domNode_0.children, options_0)}</figure>;
    };
    t4 = (domNode_1, options_1) => {
      const attribs_0 = domNode_1.attribs || {};
      const props_0 = mapAttribsToProps(attribs_0);
      const mergedClass_0 = cn("relative w-[calc(100%+2px)] min-w-full -ml-[1px] -my-[1px]", contentVariantMap.default.border, props_0.className);
      delete props_0.className;
      return <div className={cn("rounded-lg overflow-hidden border", contentVariantMap.default.background, contentVariantMap.default.border)}><table {...props_0} className={mergedClass_0}>{domToReact(domNode_1.children, options_1)}</table></div>;
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (domNode_3, options_3) => {
      const attribs_2 = domNode_3.attribs || {};
      const props_2 = mapAttribsToProps(attribs_2);
      const mergedClass_1 = cn("text-gray-900 p-4 border", contentVariantMap.default.border, props_2.className);
      delete props_2.className;
      return <td {...props_2} className={mergedClass_1}>{domToReact(domNode_3.children, options_3)}</td>;
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      a: _temp,
      figure: t3,
      table: t4,
      tr: _temp2,
      td: t5,
      img: _temp3,
      p: (domNode_5, options_5) => {
        const attribs_4 = domNode_5.attribs || {};
        const props_4 = mapAttribsToProps(attribs_4);
        const mergedClass_3 = cn("text-lg md:text-xl leading-[140%]", contentVariantMap.default.border, props_4.className);
        delete props_4.className;
        return <p {...props_4} className={mergedClass_3}>{domToReact(domNode_5.children, options_5)}</p>;
      },
      ul: (domNode_6, options_6) => {
        const attribs_5 = domNode_6.attribs || {};
        const props_5 = mapAttribsToProps(attribs_5);
        const mergedClass_4 = cn("text-lg md:text-xl leading-[140%] list-disc ml-8 space-y-1", contentVariantMap.default.border, props_5.className);
        delete props_5.className;
        return <ul {...props_5} className={mergedClass_4}>{domToReact(domNode_6.children, options_6)}</ul>;
      },
      ol: (domNode_7, options_7) => {
        const attribs_6 = domNode_7.attribs || {};
        const props_6 = mapAttribsToProps(attribs_6);
        const mergedClass_5 = cn("text-lg md:text-xl leading-[140%] ml-8 space-y-1", contentVariantMap.default.border, props_6.className);
        delete props_6.className;
        return <ol {...props_6} className={mergedClass_5}>{domToReact(domNode_7.children, options_7)}</ol>;
      },
      li: (domNode_8, options_8) => {
        const attribs_7 = domNode_8.attribs || {};
        const props_7 = mapAttribsToProps(attribs_7);
        const mergedClass_6 = cn("text-lg md:text-xl leading-[140%]", contentVariantMap.default.border, props_7.className);
        delete props_7.className;
        return <li {...props_7} className={mergedClass_6}>{domToReact(domNode_8.children, options_8)}</li>;
      },
      blockquote: _temp4,
      span: _temp5
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const replacementsMap = t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      news: "Berita",
      announcement: "Pengumuman",
      blog: "Blog"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const categoryLabels = t7;
  let t8;
  if ($[8] !== publishedDate) {
    t8 = publishedDate && <div className="text-lg font-medium text-gray-600">{formatDate(publishedDate)}</div>;
    $[8] = publishedDate;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== fullTitle) {
    t9 = <h1 className="text-5xl sm:text-[56px] font-bold md:leading-[113%]">{fullTitle}</h1>;
    $[10] = fullTitle;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <div className="space-y-4">{t8}{t9}</div>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== categories) {
    t11 = categories && categories?.length > 0 && <div className="mt-6">{categories?.map((category_0, index) => <span className="inline-flex border border-gray-300 rounded-lg mr-2 mb-1 px-2 py-1 text-sm font-semibold text-gray-900" key={`article-category-${category_0}-${index}`}>{categoryLabels[category_0 as ArticleCategory]}</span>)}</div>;
    $[15] = categories;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="font-medium">Bagikan:</div>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <WhatsappIcon className="size-5 text-gray-600" />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== url) {
    t14 = <WhatsappShareButton url={url}>{t13}</WhatsappShareButton>;
    $[19] = url;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <LinkedinIcon className="size-5 text-gray-600" />;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== url) {
    t16 = <LinkedinShareButton url={url}>{t15}</LinkedinShareButton>;
    $[22] = url;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <XIcon className="size-5 text-gray-600" />;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== url) {
    t18 = <TwitterShareButton url={url}>{t17}</TwitterShareButton>;
    $[25] = url;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <FacebookIcon className="size-5 text-gray-600" />;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== url) {
    t20 = <FacebookShareButton url={url}>{t19}</FacebookShareButton>;
    $[28] = url;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== url) {
    t21 = () => handleCopyClipboard(url);
    $[30] = url;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <LinkIcon className="size-5 text-gray-600" />;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== t21) {
    t23 = <Button size="icon" variant="ghost" className="size-5" onClick={t21}>{t22}</Button>;
    $[33] = t21;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t14 || $[36] !== t16 || $[37] !== t18 || $[38] !== t20 || $[39] !== t23) {
    t24 = <div className="mt-7 sm:mt-10 mb-12 sm:mb-[60px] text-lg flex gap-4 items-center">{t12}<div className="flex-1 flex items-center gap-3">{t14}{t16}{t18}{t20}{t23}</div></div>;
    $[35] = t14;
    $[36] = t16;
    $[37] = t18;
    $[38] = t20;
    $[39] = t23;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== image?.data?.attributes?.alternativeText || $[42] !== image?.data?.attributes?.height || $[43] !== image?.data?.attributes?.name || $[44] !== image?.data?.attributes?.url || $[45] !== image?.data?.attributes?.width) {
    t25 = image?.data?.attributes?.url && <Image src={image?.data?.attributes?.url || ""} alt={image?.data?.attributes?.alternativeText || image?.data?.attributes?.name || ""} width={image?.data?.attributes?.width || 872} height={image?.data?.attributes?.height || 480} className="h-[201px] sm:h-[442px] md:h-[480px] w-full object-cover object-center rounded-3xl bg-gray-100" />;
    $[41] = image?.data?.attributes?.alternativeText;
    $[42] = image?.data?.attributes?.height;
    $[43] = image?.data?.attributes?.name;
    $[44] = image?.data?.attributes?.url;
    $[45] = image?.data?.attributes?.width;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== content) {
    t26 = <div className="pb-10 pt-8 sm:pt-9 md:pt-10"><HtmlParser data={content} redefine={replacementsMap} /></div>;
    $[47] = content;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== t25 || $[50] !== t26) {
    t27 = <div>{t25}{t26}</div>;
    $[49] = t25;
    $[50] = t26;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== tagsData) {
    t28 = tagsData && tagsData?.length > 0 && <div><span className="inline-flex text-xs mr-2 mb-1">Tags : </span>{tagsData?.map(_temp6)}</div>;
    $[52] = tagsData;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <hr className="my-4" />;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] !== t10 || $[56] !== t11 || $[57] !== t24 || $[58] !== t27 || $[59] !== t28) {
    t30 = <div className="mx-auto lg:w-[872px] px-4 pt-14 sm:pt-20 md:pt-36 pb-10">{t10}{t11}{t24}{t27}{t28}{t29}</div>;
    $[55] = t10;
    $[56] = t11;
    $[57] = t24;
    $[58] = t27;
    $[59] = t28;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  return t30;
}
function _temp6(tag, index_0) {
  return <span className="inline-flex border border-gray-200 rounded-full mr-2 mb-1 px-2 py-1 text-xs text-gray-700" key={`article-tag-${index_0}`}>{tag}</span>;
}
function _temp5(domNode_10, options_10) {
  const attribs_9 = domNode_10.attribs || {};
  const props_9 = mapAttribsToProps(attribs_9);
  delete props_9.className;
  return <span style={{
    ...props_9.style
  }} {...props_9}>{domToReact(domNode_10.children, options_10)}</span>;
}
function _temp4(domNode_9, options_9) {
  const attribs_8 = domNode_9.attribs || {};
  const props_8 = mapAttribsToProps(attribs_8);
  delete props_8.className;
  return <div {...props_8} className="p-6 bg-primary-50 border-l-4 border-primary-400">{domToReact(domNode_9.children, options_9)}</div>;
}
function _temp3(domNode_4, options_4) {
  const attribs_3 = domNode_4.attribs || {};
  const props_3 = mapAttribsToProps(attribs_3);
  const mergedClass_2 = cn("inline-block", props_3.className, props_3.class);
  delete props_3.className;
  return <img {...props_3} className={mergedClass_2} />;
}
function _temp2(domNode_2, options_2) {
  const attribs_1 = domNode_2.attribs || {};
  const props_1 = mapAttribsToProps(attribs_1);
  return <tr {...props_1}>{domToReact(domNode_2.children, options_2)}</tr>;
}
function _temp(domNode, options) {
  const href = domNode.attribs.href;
  return <Link href={href} target="_blank" className="hover:text-primary-600">{domToReact(domNode.children, options)}</Link>;
}